import { render, staticRenderFns } from "./problemEdit.vue?vue&type=template&id=63da861d&scoped=true"
import script from "./problemEdit.vue?vue&type=script&lang=js"
export * from "./problemEdit.vue?vue&type=script&lang=js"
import style0 from "./problemEdit.vue?vue&type=style&index=0&id=63da861d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da861d",
  null
  
)

export default component.exports